import { ClickAwayListener } from "@nova/component-click-away-listener"
import { closeModal } from "features/content-overlay/thunks"
import { useAppDispatch } from "integrations/redux/hooks"
import { ReactNode, useCallback } from "react"
import { ModalContainerPosition } from "themes/default-tailwind/modals"
import { FullScreen } from "themes/default-tailwind/panels"

type BaseModalProps = {
    children?: ReactNode
    backgroundClickToClose?: boolean
    position?: ModalContainerPosition
    blackoutBackground?: boolean
    onClose?: () => void
}

export const BaseModal = ({
    children,
    backgroundClickToClose = true,
    position = ModalContainerPosition.Center,
    blackoutBackground = false,
    onClose,
}: BaseModalProps) => {
    const dispatch = useAppDispatch()

    const backgroundClickHandler = useCallback(() => {
        if (onClose) {
            if (!backgroundClickToClose) {
                return
            }

            onClose()
            dispatch(closeModal())
        }
    }, [dispatch, onClose, backgroundClickToClose])

    return (
        <ClickAwayListener onClickAway={backgroundClickHandler}>
            <FullScreen positionOverrides={position} blackoutBackground={blackoutBackground}>
                <div className="flex justify-center items-center">{children}</div>
            </FullScreen>
        </ClickAwayListener>
    )
}
